<app-header></app-header>
  <div class="ultimo-acesso" role="status">
    <span *ngIf="carregandoAcesso">Carregando informações do seu acesso...</span>
    <span *ngIf="!carregandoAcesso && erroAcesso">Não foi possível consultar seu último acesso.</span>
    <ng-container *ngIf="!carregandoAcesso && !erroAcesso">
      Olá <span *ngIf="nomeUsuario"> <strong>{{ nomeUsuario }}</strong></span>,
      <span *ngIf="ultimoAcesso"> seu último acesso foi em <strong>{{ ultimoAcesso | date: 'dd/MM/yyyy HH:mm' : '-0300' }}</strong> (horário de Brasília).</span>
      <span *ngIf="!ultimoAcesso"> ainda não há um acesso anterior registrado.</span>
    </ng-container>
  </div>
  <div class="row">
    <div class="col-md-12">
      <section class="panel panel-default panel-table" aria-labelledby="minhas-demandas-titulo">
        <div class="panel-heading">
          <h3 id="minhas-demandas-titulo">Minhas Demandas <span class="contador-demandas" *ngIf="!carregandoDemandas && !erroDemandas" [attr.aria-label]="demandas.length + ' demandas atribuídas a você'">{{ demandas.length }}</span></h3>
          <p class="panel-subtitle">Chamados atribuídos a você.</p>
        </div>
        <div class="panel-body" [attr.aria-busy]="carregandoDemandas">
          <p class="estado-demandas" *ngIf="carregandoDemandas" role="status">Carregando demandas...</p>
          <div class="alert alert-danger" *ngIf="erroDemandas" role="alert">
            Não foi possível carregar suas demandas.
            <button type="button" class="btn btn-default btn-sm" (click)="carregarDemandas()">Tentar novamente</button>
          </div>
          <p class="estado-demandas" *ngIf="!carregandoDemandas && !erroDemandas && demandas.length === 0">Nenhuma demanda atribuída a você.</p>
          <div class="table-responsive lista-demandas" *ngIf="!carregandoDemandas && !erroDemandas && demandas.length > 0">
            <table class="table table-striped table-hover">
              <thead>
                <tr><th scope="col">Número</th><th scope="col">Assunto</th><th scope="col">Solicitante</th><th scope="col">Tipo</th><th scope="col">Situação</th><th scope="col">Aberta em</th><th scope="col">Ações</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let demanda of demandas">
                  <td>{{ demanda.numero }}</td>
                  <td class="assunto-demanda">{{ demanda.assunto }}</td>
                  <td>{{ demanda.demandante?.nome || 'Não informado' }}</td>
                  <td>{{ demanda.demandatipo?.nome || 'Não informado' }}</td>
                  <td>{{ demanda.demandasituacao?.nome || 'Não informado' }}</td>
                  <td class="data-demanda">{{ demanda.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
                  <td><a class="btn btn-primary btn-sm" [routerLink]="['/demanda-exibir', demanda.codigo_demanda]" [attr.aria-label]="'Ver demanda ' + demanda.numero">Ver demanda</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  </div>
<app-footer></app-footer>
